import type { SVGProps } from 'react'

import { SvgCcMastercard } from '~/components/icons/cc-mastercard'
import { SvgCcVisa } from '~/components/icons/cc-visa'
import { SvgCreditCard } from '~/components/icons/credit-card'

export const PaymentMethodCardIcon = ({
	brand,
	...props
}: { brand?: string } & SVGProps<SVGSVGElement>) => {
	if (brand === 'visa') return <SvgCcVisa {...props} />
	if (brand === 'mastercard') return <SvgCcMastercard {...props} />
	return <SvgCreditCard {...props} />
}
